export type AddOnServiceView = {
  id: number;
  name: string;
  netPrice: number;
  taxRateId: number;
  grossPrice?: number;
  currencyId: number;
  unitOfMeasureId: number;
  calculationMethodId?: number;
  applyToAllProperties: boolean;
  automaticallyAddToReservations: boolean;
  isCityTax: boolean;
  isTransfer: boolean;
  isAvailableViaBookingEngine: boolean;
  pricesAreSeasonal: boolean;
  firstPropertyName: string;
  isPPOM: boolean;
  ppomTaxCategoryId?: number;
};

export class AddOnServiceModel {
  id = 0;
  name = "";
  netPrice = 0;
  taxRateId = 0;
  grossPrice = 0;
  currencyId = 0;
  unitOfMeasureId = 1;
  calculationMethodId = 0;
  applyToAllProperties = false;
  automaticallyAddToReservations = false;
  isCityTax = false;
  isBookingFee = false;
  isTransfer = false;
  isAvailableViaBookingEngine = false;
  isFoodAndBeverages = false;
  isRelative = false;

  konto = "";
  pricesAreSeasonal = false;
  consumptionTaxRate: number | null = null;
  ownerPayoutAmount: number | undefined;
  ownerPayoutIsAbsolute = false;
  taxExemptionReason = "";
  accUnitId = 0;

  translations = [] as AddOnServiceTranslation[];
  seasonPrices = [] as AddOnServicesSeasonPrice[];
  propertiesIds = [] as number[];

  isPPOM = false;
  ppomTaxCategoryId: number | null = null;
}

export class AddOnServiceViewModel {
  addOnServiceId = 0;
  mergeToAccommodationWhenInvoicing = false;
}

export class AddOnServiceTranslation {
  id = 0;
  addOnServiceId = 0;
  cultureCode = "";
  translation = "";
}

export class AddOnServicesSeasonPrice {
  id = 0;
  addOnServiceId = 0;
  netPrice = 0;
  grossPrice = 0;
  dateFrom = "";
  dateUntil = "";
  ownerPayoutAmountSeason? = 0;
  ownerPayoutIsAbsoluteSeason? = false;
}

export interface AddOnServiceViewForFinancialDocuments {
  id: number;
  name: string;
  grossPrice: number;
  taxRateId: number;
  currencyId: number;
  unitOfMeasureId: number;
  isCityTax: boolean;
  isBookingFee: boolean;
  consumptionTaxRate: number | null;
  isFoodAndBeverages: boolean;
  isRelative: boolean;
  taxExemptionReason: string;
}
